import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  HostListener,
  Injectable,
  Renderer2,
  ViewChild, ViewEncapsulation
} from '@angular/core';
import {Component, OnInit, Input} from '@angular/core';
import {MatDialog, MatDialogRef, MatDialogConfig} from '@angular/material';
import {DatePipe} from '@angular/common';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material';

import {CoursDTO} from '../../model/coursDTO.model';
import {Cours} from '../../model/cours.model';
import {Utilisateur} from '../../model/utilisateur.model';
import {Client} from '../../model/client.model';
import {ResaMultiple} from '../../model/resaMultiple.model';
import {Reservation} from '../../model/reservation.model';

import {CoursService} from '../../service/cours.service';
import {ClientService} from '../../service/client.service';
import {ReservationService} from '../../service/reservation.service';
import * as moment from 'moment';
import * as localization from 'moment/locale/fr';
import {DaterangepickerDirective} from 'ngx-datepicker-material';
import {Moment} from 'moment';
import {ConfigService} from '../../shared/config.service';

import { ConfirmDialogModel, ConfirmDialogComponent } from '../../administration/confirm-dialog/confirm-dialog.component';
moment.locale('fr', localization);

// import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-cours',
  templateUrl: './cours.component.html',
  styleUrls: ['./cours.component.scss'],
  encapsulation: ViewEncapsulation.None
})

// @Injectable()
export class CoursComponent implements OnInit {
  @ViewChild(DaterangepickerDirective) daterangepicker: DaterangepickerDirective;
  @ViewChild('datePicker') dpElement: ElementRef;
  @ViewChild('pickerButton') pickerButton: ElementRef;
  locale = {
    applyLabel: 'Appliquer',
    customRangeLabel: ' - ',
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    firstDay: moment.localeData().firstDayOfWeek(),
  };
  dateDuJour: Date = new Date();
  maDate: Date;
  dateInput: any;
  // nbjourShow = 7 - this.dateDuJour.getDay();
  nbjourShow = 6
  nbjourParcours = 0;

  disableNext = false;
  disableprev = true;
  minDate: Moment;
  maxDate: Moment;
  dialogRef: MatDialogRef<FamilleMemberComponent>;
  lastCloseResult: string;
  config: MatDialogConfig = {
    disableClose: false,
    width: '90vw',
    maxWidth: '450px',
    // maxHeight: '',
    panelClass: 'app-dialog-overlay',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    }
  };


  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;

  mesCours: CoursDTO[];
  currentUser: Utilisateur;
  clients: Client[];
  datePipe: DatePipe;

  isfamille = false;


  myFilter = (d: Date): boolean => {
    // const day = d.getDay();

    const dayDeb = new Date();
    const dayFin = new Date();

    dayFin.setDate(dayFin.getDate() + this.nbjourShow);
    dayDeb.setDate(dayDeb.getDate() - 1);

    // console.log(dayDeb, dayFin);

    //  Prevent Saturday and Sunday from being selected.
    return d >= dayDeb && d <= dayFin;
  }


  constructor(public dialog: MatDialog,
              private coursService: CoursService,
              private clientService: ClientService,
              private reservationService: ReservationService,
              // private spinner: NgxSpinnerService,
              public snackBar: MatSnackBar,
              private renderer: Renderer2,
              private cdr: ChangeDetectorRef,
              private configService: ConfigService
  ) {

    this.datePipe = new DatePipe('en-US');

  }

  ngOnInit() {
    // this.spinner.show();


    this.maDate = new Date();
    this.dateInput = moment();
    this.minDate = moment();
    this.maxDate = moment().add(this.nbjourShow, 'days');
    // console.log(this.minDate, this.maxDate);
    // var datePipe = new DatePipe("en-US");

    // console.log(datePipe.transform(this.maDate,'yyyy-MM-dd'));

    this.currentUser = JSON.parse(sessionStorage.getItem('parklife'));
    this.clientService.getByPere(this.currentUser.idclient).subscribe(membres => {
      this.clients = membres;
      if (this.clients.length === 1) {
        this.isfamille = false;
      } else {
        this.isfamille = true;

      }
    });

    this.afficherCours(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.currentUser.idclient);

    this.reservationService._actionDelete.subscribe(resp => {
      if (resp) {
        // console.log('delecte action');
        this.afficherCours(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.currentUser.idclient);
      }
    });

    // this.coursService.getByDateDebutClient(datePipe.transform(this.maDate,'yyyy-MM-dd'),this.currentUser.idclient).subscribe(res => {
    //   this.mesCours = res
    // });
  }

  reserver(idcours: string, index) {
    //confirm dialog
    const message = `Voulez-vous vraiment confirmer votre réservation ?`;
    const dialogData = new ConfirmDialogModel("Réservation activité", message);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      panelClass: 'confirm-dialog',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      // Traitement
      if (this.clients.length === 1 && dialogResult) {
        const config = new MatSnackBarConfig();
        this.clientService.get(this.currentUser.idclient).subscribe(client => {
          const resa = new Reservation();
          const cours = new Cours();
          cours.idcours = idcours;

          resa.client = client;
          resa.cours = cours;

          // console.log(resa);

          this.reservationService.create(resa).subscribe(res => {
            if (res && res.dateresa != null) {


              /* this.afficherCours(this.datePipe.transform(this.maDate,'yyyy-MM-dd'),this.currentUser.idclient);

              let date = new Date();
              var datePipe = new DatePipe("en-US");
              this.reservationService.getByClient(this.datePipe.transform(date,'yyyy-MM-dd'),this.currentUser.idclient).subscribe(res => {
                sessionStorage.setItem('resa', JSON.stringify(res));

              }); */

              this.coursService.getbyclient(idcours, this.currentUser.idclient).subscribe(res => {
                // this.mesCours[index] = res;
                this.mesCours[index].nombreplace = Number(res.nombreplace);
                this.mesCours[index].participants = res.participants;
                this.mesCours[index].placedispo = res.placedispo;
                this.mesCours[index].reserve = res.reserve;

                const date = new Date();
                const datePipe = new DatePipe('en-US');
                this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
                  sessionStorage.setItem('resa', JSON.stringify(res));
                  this.configService.nbReservationCours.next(res.length);
                });


              });


              config.duration = this.autoHide;
              config.panelClass = this.addExtraClass ? ['party'] : null;
              this.snackBar.open('Votre réservation a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);

            } else {
              config.duration = this.autoHide;
              config.extraClasses = this.addExtraClass ? ['party'] : null;
              this.snackBar.open('Place non disponible.', this.action && this.actionButtonLabel, config);
            }
          }, error => {
            config.duration = this.autoHide;
            config.extraClasses = this.addExtraClass ? ['party'] : null;
            this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre reservation.', this.action && this.actionButtonLabel, config);
          });


        }, error => {

          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre reservation.', this.action && this.actionButtonLabel, config);


        });


      } /*else {

        this.dialogRef = this.dialog.open(FamilleMemberComponent, this.config);
        this.dialogRef.componentInstance.idCours = idcours;
        this.dialogRef.componentInstance.membreFamille = this.clients;

        this.dialogRef.afterClosed().subscribe(result => {

          this.afficherCours(this.datePipe.transform(this.maDate,'yyyy-MM-dd'),this.currentUser.idclient);

            let date = new Date();
              var datePipe = new DatePipe("en-US");
              this.reservationService.getByClient(this.datePipe.transform(date,'yyyy-MM-dd'),this.currentUser.idclient).subscribe(res => {
                sessionStorage.setItem('resa', JSON.stringify(res));

              });

          this.lastCloseResult = result;
          this.dialogRef = null;

        });
      } */

    });



  }


  remove(idcours: string, index) {
    //confirm dialog
    const message = `Voulez-vous vraiment annuler votre réservation ?`;
    const dialogData = new ConfirmDialogModel("Annulation réservation activité", message);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      panelClass: 'confirm-dialog',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {

        this.reservationService.deleteClientCours(idcours, this.currentUser.idclient).subscribe(res => {
          this.coursService.getbyclient(idcours, this.currentUser.idclient).subscribe(res => {
            // this.mesCours[index] = res;
            this.mesCours[index].nombreplace = Number(res.nombreplace);
            this.mesCours[index].participants = res.participants;
            this.mesCours[index].placedispo = res.placedispo;
            this.mesCours[index].reserve = res.reserve;

            const date = new Date();
            const datePipe = new DatePipe('en-US');
            this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
              sessionStorage.setItem('resa', JSON.stringify(res));
              this.configService.nbReservationCours.next(res.length);
            });

          });
        });

      }
    });
  }

  afficherCours(date: string, clientId: string) {
    this.coursService.getByDateDebutClient(date, clientId).subscribe(res => {
      this.mesCours = res.filter(cours => {
        return ((cours.nombreplace >= 0) && (cours.depasse === false));
      });
      // this.spinner.hide();
    });
  }

  nextDate() {
    // this.maDate = new Date(this.dateDuJour.setDate(this.dateDuJour.getDate() + 1)) ;
    this.maDate = new Date(this.maDate.setDate(this.maDate.getDate() + 1));
    // this.dateDuJour.setDate (this.maDate.getDate());
    // this.nbjourParcours = this.nbjourParcours + 1;
    this.disableprev = false;
    let currentDate = new Date(this.maDate), dateLimit = new Date(this.dateDuJour);

    currentDate.setHours(0, 0, 0, 0);
    dateLimit.setHours(0, 0, 0, 0);


    // currentDate.setDate (currentDate.getDate());
    dateLimit.setDate(dateLimit.getDate() + this.nbjourShow);


    // console.log(this.maDate, +currentDate, ' -- ', this.dateDuJour,  +dateLimit);

    /* if (this.nbjourParcours >= this.nbjourShow ) {
      this.disableNext = true;
    } */

    // console.log(currentDate, dateLimit);

    if (+currentDate >= +dateLimit) {
      this.disableNext = true;
    }
    // console.log(this.maDate);
    // console.log(this.dateDuJour);
    // console.log(this.nbjourParcours);
    this.dateInput = this.dateInput.startDate ? this.dateInput.startDate.add(1, 'days') : this.dateInput.add(1, 'days');
    this.daterangepicker.writeValue({startDate: this.dateInput, endDate: this.dateInput});
    this.daterangepicker.picker.updateView();
    this.cdr.detectChanges();

    this.afficherCours(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.currentUser.idclient);
    const date = new Date();
    this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
      sessionStorage.setItem('resa', JSON.stringify(res));
      this.configService.nbReservationCours.next(res.length);
    });


  }

  prevDate() {

    // this.maDate = new Date(this.dateDuJour.setDate(this.dateDuJour.getDate() - 1)) ;
    this.maDate = new Date(this.maDate.setDate(this.maDate.getDate() - 1));
    /* this.nbjourParcours = this.nbjourParcours - 1; */
    this.disableNext = false;

    let currentDate = new Date(this.maDate);
    // currentDate.setDate (currentDate.getDate() - 1);
    currentDate.setHours(0, 0, 0, 0);
    this.dateDuJour.setHours(0, 0, 0, 0);

    if (+currentDate <= +this.dateDuJour) {
      this.disableprev = true;
    }
    // console.log(this.maDate);
    // console.log(this.dateDuJour);
    // console.log(this.nbjourParcours);
    this.dateInput = this.dateInput.startDate ? this.dateInput.startDate.subtract(1, 'days') : this.dateInput.subtract(1, 'days');
    this.daterangepicker.writeValue({startDate: this.dateInput, endDate: this.dateInput});
    this.daterangepicker.picker.updateView();
    this.cdr.detectChanges();

    this.afficherCours(this.datePipe.transform(this.maDate, 'yyyy-MM-dd'), this.currentUser.idclient);
    const date = new Date();
    this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
      sessionStorage.setItem('resa', JSON.stringify(res));
      this.configService.nbReservationCours.next(res.length);
    });

  }

  selectDate(date: Date) {
    // console.log(event.value);
    this.disableNext = this.disableprev = false;
    // this.maDate = new Date(this.maDate.setDate(event.value.getDate() + 1));

    this.maDate = date;
    // this.dateDuJour = new Date(event.value);
    // console.log (this.maDate);

    // this.maDate.setDate (this.maDate.getDate() - 1);

    const currentDate = new Date(this.maDate), dateLimit = new Date(this.dateDuJour);
    dateLimit.setDate(dateLimit.getDate() + this.nbjourShow);
    dateLimit.setHours(0, 0, 0, 0);

    if (moment(currentDate).isAfter(dateLimit) || moment(currentDate).isSame(dateLimit)) {
      this.disableNext = true;
    }

    if (currentDate.getDate() === this.dateDuJour.getDate()) {
      this.disableprev = true;
    }

    this.afficherCours(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient);
  }


  removemembre(coursId, index) {


    this.dialogRef = this.dialog.open(FamilleMemberComponent, this.config);
    this.dialogRef.componentInstance.idCours = coursId;
    // this.dialogRef.componentInstance.membreFamille = this.clients;
    this.dialogRef.componentInstance.addremove = 'remove';
    this.dialogRef.componentInstance.idPere = this.currentUser.idclient;

    this.dialogRef.afterClosed().subscribe(result => {


      this.coursService.getbyclient(coursId, this.currentUser.idclient).subscribe(res => {
        // this.mesCours[index] = res;
        this.mesCours[index].nombreplace = Number(res.nombreplace);
        this.mesCours[index].participants = res.participants;
        this.mesCours[index].placedispo = res.placedispo;
        this.mesCours[index].reserve = res.reserve;

        const date = new Date();
        const datePipe = new DatePipe('en-US');
        this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
          sessionStorage.setItem('resa', JSON.stringify(res));
          this.configService.nbReservationCours.next(res.length);
        });


      });

      //  this.afficherCours(this.datePipe.transform(this.maDate,'yyyy-MM-dd'),this.currentUser.idclient);


      this.lastCloseResult = result;
      this.dialogRef = null;

    });

  }

  addmembre(coursId, index) {


    this.dialogRef = this.dialog.open(FamilleMemberComponent, this.config);
    this.dialogRef.componentInstance.idCours = coursId;
    // this.dialogRef.componentInstance.membreFamille = this.clients;
    this.dialogRef.componentInstance.addremove = 'add';
    this.dialogRef.componentInstance.idPere = this.currentUser.idclient;

    this.dialogRef.afterClosed().subscribe(result => {


      this.coursService.getbyclient(coursId, this.currentUser.idclient).subscribe(res => {
        //  this.mesCours[index].datedebut = res.datedebut;
        //  this.mesCours[index].datefin = res.datefin;
        //  this.mesCours[index].designation = res.designation;
        this.mesCours[index].nombreplace = Number(res.nombreplace);
        this.mesCours[index].participants = res.participants;
        this.mesCours[index].placedispo = res.placedispo;
        this.mesCours[index].reserve = res.reserve;

        const date = new Date();
        const datePipe = new DatePipe('en-US');
        this.reservationService.getByClient(this.datePipe.transform(date, 'yyyy-MM-dd'), this.currentUser.idclient).subscribe(res => {
          sessionStorage.setItem('resa', JSON.stringify(res));
          this.configService.nbReservationCours.next(res.length);
        });


      });

      //  this.afficherCours(this.datePipe.transform(this.maDate,'yyyy-MM-dd'),this.currentUser.idclient);


      this.lastCloseResult = result;
      this.dialogRef = null;

    });


  }

  // gestion date picker
  clickDatePicker() {
    this.renderer.removeClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'hidden');
    this.renderer.addClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'shown');
  }

  hideCalendar() {
    this.renderer.removeClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'shown');
    this.renderer.addClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'hidden');
    this.selectDate(this.dateInput.startDate.toDate());
  }
  @HostListener('document:click', ['$event.target'])

  public onClickOutSide(targetElement) {
    const clickedInside = this.daterangepicker.picker.pickerContainer.nativeElement.contains(targetElement);
    if (!clickedInside && !this.pickerButton.nativeElement.contains(targetElement)) {
      this.renderer.removeClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'shown');
      this.renderer.addClass(this.renderer.nextSibling(this.dpElement.nativeElement).children[0], 'hidden');
    }
  }

}

@Component({
  selector: 'app-familleMember-dialog',
  templateUrl: 'famille-membres-dialog.html'

})
export class FamilleMemberComponent {


  @Input()
  idCours: any;

  @Input()
  idPere: any;

  @Input()
  idEspace: any;

  @Input()
  addremove: any;

  selectedclient: Client[];
  membreFamille: Client[];

  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;

  titre: string;

  constructor(public dialogRef: MatDialogRef<FamilleMemberComponent>,
              private reservationService: ReservationService,
              private clientService: ClientService,
              public snackBar: MatSnackBar) {

    // console.log(this.idCours);
  }

  ngOnInit() {

    if (this.addremove === 'add') {
      this.titre = 'Ajouter des participants';
      this.clientService.getClientNoResaCours(this.idCours, this.idPere).subscribe(res => {
        this.membreFamille = res;
      });
    }

    if (this.addremove === 'remove') {
      this.titre = 'Retirer des participants';
      this.clientService.getClientResaCours(this.idCours, this.idPere).subscribe(res => {
        this.membreFamille = res;
      });
    }


  }

  valider(row) {
    // console.log(row.selectedOptions.selected);
    const resaMultiple = new ResaMultiple();
    this.selectedclient = [];

    row.selectedOptions.selected.forEach(element => {
      this.selectedclient.push(element.value)


    });

    resaMultiple.coursId = this.idCours;
    resaMultiple.clients = this.selectedclient;
    // console.log(resaMultiple);

    if (this.addremove === 'add') {
      this.reservationService.createMultiple(resaMultiple).subscribe(res => {
        // console.log(res);
        const config = new MatSnackBarConfig();
        if (res === true) {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Votre réservation a été enregistrée avec succès.', this.action && this.actionButtonLabel, config);
        } else {
          config.duration = this.autoHide;
          config.extraClasses = this.addExtraClass ? ['party'] : null;
          this.snackBar.open('Place non disponible.', this.action && this.actionButtonLabel, config);
        }


      }, error => {
        const config = new MatSnackBarConfig();
        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Une erreur a été rencontrée lors de l\'enregistrement de votre reservation.', this.action && this.actionButtonLabel, config);

      });
    }

    if (this.addremove === 'remove') {
      this.reservationService.deleteMultiple(resaMultiple).subscribe();

    }


    this.dialogRef.close();


  }
}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/reservation/cours/cours.component.ts